import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ErrorItem {
  id: string;
  timestamp: string;
  type: 'api' | 'validation' | 'network' | 'operation';
  severity: 'error' | 'warning' | 'info';
  title: string;
  message: string;
  details?: any;
  operationId?: string;
  acknowledged: boolean;
}

interface ErrorState {
  errors: ErrorItem[];
  unreadCount: number;
  showErrorConsole: boolean;
}

const initialState: ErrorState = {
  errors: [],
  unreadCount: 0,
  showErrorConsole: false,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    addError: (state, action: PayloadAction<Omit<ErrorItem, 'id' | 'timestamp' | 'acknowledged'>>) => {
      const error: ErrorItem = {
        ...action.payload,
        id: Date.now().toString(),
        timestamp: new Date().toISOString(),
        acknowledged: false,
      };
      state.errors.unshift(error);
      if (!error.acknowledged) {
        state.unreadCount++;
      }
      // Keep only last 100 errors
      if (state.errors.length > 100) {
        state.errors = state.errors.slice(0, 100);
      }
    },
    acknowledgeError: (state, action: PayloadAction<string>) => {
      const error = state.errors.find(e => e.id === action.payload);
      if (error && !error.acknowledged) {
        error.acknowledged = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    clearAllErrors: (state) => {
      state.errors = [];
      state.unreadCount = 0;
    },
    toggleErrorConsole: (state) => {
      state.showErrorConsole = !state.showErrorConsole;
    },
    acknowledgeAllErrors: (state) => {
      state.errors.forEach(error => {
        error.acknowledged = true;
      });
      state.unreadCount = 0;
    },
  },
});

export const { addError, acknowledgeError, clearAllErrors, toggleErrorConsole, acknowledgeAllErrors } = errorSlice.actions;
export default errorSlice.reducer;
